<script>
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'
import {uploadFotoGrvIndividual} from '../../../../domain/grv/services'
import {STATUS_ABERTO, STATUS_FRUSTRADO, STATUS_PENDENTE} from '../../../../domain/grv/helpers/GrvStatus'

export default {
  name: 'GrvMixins',
  mixins: [AclCheckMixins],
  data () {
    return {
      listaStatusPossiveisParaAlteracao: [
        STATUS_ABERTO,
        STATUS_PENDENTE,
        STATUS_FRUSTRADO
      ]
    }
  },
  computed: {
    isGrvRegistrada () {
      const {id} = this.$route.params
      return id && id !== 'registrar'
    },
    podeEditarCampoPatio () {
      return !this.isGrvRegistrada || this.isAdministradorExclusivo
    },
    podeAlterarStatus () {
      const isStatusPermitido = this.listaStatusPossiveisParaAlteracao.some(s => s === this.data.status)
      return this.possuiACL('alterar_status_grv') && isStatusPermitido
    }
  },
  methods: {
    uploadFotoIndividualGrv: async function (grvId) {
      this.$loaderOverlay.message('Cadastrando as fotos, aguarde...')
      let counter = 0
      for (let file of this.data.arquivos) {
        if (file.apagar || !file.arquivo) continue
        ++counter
        this.$loaderOverlay.message(`Cadastrando foto ${counter} de ${(this.data.arquivos || []).length}, aguarde...`)
        try {
          await uploadFotoGrvIndividual(grvId, {data: file.arquivo, filename: 'fotoGrv'})
        } catch (error) {
          console.log('DEU RUIM', error)
        }
      }
      return new Promise(resolve => resolve(console.log('ENVIOU TODAS AS FOTOS!')))
    }
  }
}
</script>



// WEBPACK FOOTER //
// GrvMixins.vue?097a5d8d